var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { Allow } from 'class-validator';
import { TemplateExposeGroup } from '../interface';
import { ReadTemplateCohortConfigDto } from './ReadTemplateCohortConfigDto';
import { ReadTemplateWorkflowConfigDto } from './ReadTemplateWorkflowConfigDto';
export class ReadTemplateDto {
}
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4', example: 'e12acc6f-2f34-442c-92d3-d4199fb12345' }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ] }),
    Allow({ always: true }),
    __metadata("design:type", String)
], ReadTemplateDto.prototype, "uuid", void 0);
__decorate([
    ApiPropertyOptional({ description: 'ref to merchant.merchantId', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadTemplateDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ description: 'Title of campaign template.', example: 'campaign-template-title', type: () => String }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ],
    }),
    __metadata("design:type", String)
], ReadTemplateDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Description of campaign template.', example: 'campaign template description.', type: () => String }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ],
    }),
    __metadata("design:type", String)
], ReadTemplateDto.prototype, "description", void 0);
__decorate([
    ApiProperty({ description: 'List of config by cohort.', type: () => ReadTemplateCohortConfigDto, isArray: true }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    Type(() => ReadTemplateCohortConfigDto),
    __metadata("design:type", Array)
], ReadTemplateDto.prototype, "cohorts", void 0);
__decorate([
    ApiProperty({ description: 'List of config by workflow.', type: () => ReadTemplateWorkflowConfigDto, isArray: true }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    Type(() => ReadTemplateWorkflowConfigDto),
    __metadata("design:type", Array)
], ReadTemplateDto.prototype, "workflowDefinitions", void 0);
__decorate([
    ApiProperty({ description: 'Flag determine whether campaign runs once or multiple times.', type: () => Boolean }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ],
    }),
    __metadata("design:type", Boolean)
], ReadTemplateDto.prototype, "runItOnce", void 0);
//# sourceMappingURL=ReadTemplateDto.js.map